var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDivision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.096,
    height: 40,
    viewBox: "0 0 53.096 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49",
    transform: "translate(-823.948 -384)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_1_1",
    "data-name": "Component 1 \\u2013 1",
    transform: "translate(856.404 393.728)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(0 -2.326)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    x2: 15.943,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    "data-name": "Line 7",
    x2: 15.943,
    transform: "translate(0 17.082)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "D",
    d: "M1.561,0V-11.9H4.848q6.292,0,6.292,5.8A5.847,5.847,0,0,1,9.392-1.673,6.482,6.482,0,0,1,4.715,0ZM2.955-10.642v9.38H4.731A5.041,5.041,0,0,0,8.375-2.515a4.7,4.7,0,0,0,1.3-3.553q0-4.574-4.864-4.574Z",
    transform: "translate(1.621 12.166)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "education-bag-learning-32-svgrepo-com",
    d: "M33.021,21.416H31.688A6.159,6.159,0,0,0,26.3,15.693a4.971,4.971,0,1,0-5.115,0A6.159,6.159,0,0,0,15.8,21.416H13.58a.381.381,0,0,0-.07-.206.961.961,0,0,1,0-1.163.381.381,0,0,0,.071-.206h1.8a.384.384,0,0,0,.384-.384V19.1a.382.382,0,0,0-.079-.233.961.961,0,0,1,0-1.163.383.383,0,0,0,.08-.233v-.357a.384.384,0,0,0-.384-.384H13.717a.378.378,0,0,0-.07-.206.959.959,0,0,1,0-1.163.387.387,0,0,0,.079-.233v-.356a.384.384,0,0,0-.384-.384H8.1a1.555,1.555,0,1,0,0,3.11h.7a1.517,1.517,0,0,0,0,1.575h-.84A1.553,1.553,0,0,0,6.687,21.51a.378.378,0,0,0-.14.29v3.964a.384.384,0,0,0,.384.384H9.105V32.99a.384.384,0,0,0,.384.384H30.463a.384.384,0,0,0,.384-.384V26.148h2.174a.384.384,0,0,0,.384-.384V21.8A.384.384,0,0,0,33.021,21.416ZM19.543,11.44a4.2,4.2,0,1,1,4.2,4.2A4.208,4.208,0,0,1,19.543,11.44Zm2.4,4.97h3.61a5.4,5.4,0,0,1,5.376,5.005H16.566A5.4,5.4,0,0,1,21.941,16.41ZM7.315,15.942a.785.785,0,0,1,.788-.788h4.77a1.736,1.736,0,0,0,0,1.575H8.1A.787.787,0,0,1,7.315,15.942Zm2.037,2.343a.786.786,0,0,1,.789-.788h4.77a1.738,1.738,0,0,0,0,1.575h-4.77A.788.788,0,0,1,9.352,18.285ZM7.409,20.07a.783.783,0,0,1,.558-.23h4.771a1.739,1.739,0,0,0,0,1.576H7.966a.789.789,0,0,1-.558-1.346ZM30.08,32.606H9.872V26.147H30.08Zm2.558-7.226H7.315v-3.2H32.637Z",
    transform: "translate(822.355 389.487)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46",
    transform: "translate(823.948 384)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "box-fragile-svgrepo-com",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M50.491,51.307H2.6A2.536,2.536,0,0,0,0,53.761V88.853a2.536,2.536,0,0,0,2.6,2.454H50.491a2.536,2.536,0,0,0,2.6-2.454V53.761A2.536,2.536,0,0,0,50.491,51.307Zm.942,37.546a.917.917,0,0,1-.942.888H2.6a.917.917,0,0,1-.942-.888V53.761a.917.917,0,0,1,.942-.888H50.491a.917.917,0,0,1,.942.888V88.853Z",
    transform: "translate(0 -51.307)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDivision);
export default __webpack_public_path__ + "static/media/division.d29febc2d5c7a8da7d1104ce0f6ab7bd.svg";
export { ForwardRef as ReactComponent };